import {
  default as MuiSkeleton,
  type SkeletonProps as MuiSkeletonProps,
} from '@mui/material/Skeleton';
import { styles } from './utils';

export interface SkeletonProps extends Omit<MuiSkeletonProps, 'sx'> {
  delay?: number;
  radius?: number | string;
}

export default function Skeleton({
  delay = 0,
  radius,
  variant = 'rounded',
  ...props
}: SkeletonProps) {
  return (
    <MuiSkeleton
      sx={{
        ...(radius !== undefined && { borderRadius: radius }),
        ...styles.wave(delay),
      }}
      variant={variant}
      animation="wave"
      {...props}
    />
  );
}
